function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  transform: "translate(2 2)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M9.9985,17.938 C9.5015,17.938 9.0705,17.568 9.0075,17.062 C8.9395,16.514 9.3285,16.014 9.8765,15.946 C13.3675,15.51 15.9995,12.524 15.9995,9 C15.9995,5.14 12.8595,2 8.9995,2 C5.8045,2 3.0165,4.158 2.2205,7.249 C2.0825,7.784 1.5405,8.105 1.0025,7.968 C0.4685,7.83 0.1465,7.285 0.2845,6.75 C1.3075,2.776 4.8915,0 8.9995,0 C13.9625,0 17.9995,4.038 17.9995,9 C17.9995,13.531 14.6145,17.37 10.1235,17.93 C10.0815,17.936 10.0405,17.938 9.9985,17.938"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M12 13C11.744 13 11.488 12.902 11.293 12.707L8.293 9.707C8.105 9.52 8 9.265 8 9L8 5C8 4.448 8.448 4 9 4 9.552 4 10 4.448 10 5L10 8.586 12.707 11.293C13.098 11.684 13.098 12.316 12.707 12.707 12.512 12.902 12.256 13 12 13M6.707 10.293L5.707 9.293C5.316 8.902 4.684 8.902 4.293 9.293 4.098 9.488 4.012 9.744 4.012 10L1.498 10C.672 10 0 10.672 0 11.498L0 13C0 13.552.448 14 1 14 1.552 14 2 13.552 2 13L2 12 5 12 6 12C6.404 12 6.769 11.756 6.924 11.383 7.079 11.009 6.993 10.579 6.707 10.293M7 13C6.448 13 6 13.448 6 14L6 15 3 15 2 15C1.596 15 1.231 15.244 1.076 15.617.921 15.991 1.007 16.421 1.293 16.707L2.293 17.707C2.488 17.902 2.744 18 3 18 3.256 18 3.512 17.902 3.707 17.707 3.902 17.512 3.988 17.256 3.988 17L6.502 17C7.328 17 8 16.328 8 15.502L8 14C8 13.448 7.552 13 7 13"
}));

var SvgSchedules = function SvgSchedules(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgSchedules;